import { connect } from "react-redux";
import { checkoutItem } from "../ItemsCheckout/state/actions";
import ItemsSearchComponent from "./ItemsSearch";
import {
  clearResults,
  fetchAndCheckoutIfOne,
  updateQueryString,
} from "./state/actions";

const mapDispatchToProps = (dispatch) => ({
  fetchAndCheckoutIfOne: (barcode, patronPid, onSuccess) =>
    dispatch(fetchAndCheckoutIfOne(barcode, patronPid, onSuccess)),
  updateQueryString: (qs) => dispatch(updateQueryString(qs)),
  clearResults: () => dispatch(clearResults()),
  checkoutItem: (documentPid, itemPid, patronPid, payload = {}) =>
    dispatch(checkoutItem(documentPid, itemPid, patronPid, payload)),
});

const mapStateToProps = (state) => ({
  checkoutData: state.patronItemsCheckout.data,
  checkoutHasError: state.patronItemsCheckout.hasError,
  checkoutLoading: state.patronItemsCheckout.isLoading,
  error: state.itemsSearchInput.error,
  hasError: state.itemsSearchInput.hasError,
  isLoading: state.patronDetails.isLoading,
  isLoadingSearch: state.patronItemsSearch.isLoading,
  items: state.itemsSearchInput.data,
  patronData: state.patronDetails.data,
  patronDetails: state.patronDetails.data,
  borrowingStats: state.patronDetails.borrowingStats,
  currentLoans: state.patronCurrentLoans,
  queryString: state.itemsSearchInput.itemCheckoutQueryString,
});

export const ItemsSearch = connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemsSearchComponent);
